import { render, staticRenderFns } from "./PickElement.vue?vue&type=template&id=535aced2"
import script from "./PickElement.vue?vue&type=script&lang=js"
export * from "./PickElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports